/**
 * @generated SignedSource<<5f241a0445b7880cd7e45803c28933dc>>
 * @relayHash bd6f58c95f88e9d97d8fae7e1cbd74de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d244fee1ef3f2bd897b1c0da29e3fe2e702a30b6ba39c48ae98224f1f4b003f3

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectSettingsSpacePoliciesQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type ProjectSettingsSpacePoliciesQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly policyAssociations: {
        readonly nodes: ReadonlyArray<{
          readonly policy: {
            readonly description: string | null;
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type ProjectSettingsSpacePoliciesQuery = {
  response: ProjectSettingsSpacePoliciesQuery$data;
  variables: ProjectSettingsSpacePoliciesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 50
    }
  ],
  "concreteType": "JiraProjectPolicyAssociationConnection",
  "kind": "LinkedField",
  "name": "policyAssociations",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectPolicyAssociation",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectPolicy",
          "kind": "LinkedField",
          "name": "policy",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "description"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "policyAssociations(first:50)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectSettingsSpacePoliciesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSettingsSpacePoliciesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d244fee1ef3f2bd897b1c0da29e3fe2e702a30b6ba39c48ae98224f1f4b003f3",
    "metadata": {},
    "name": "ProjectSettingsSpacePoliciesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "12e542f81ede5862b36763c90f03f23f";

export default node;
